// Virtua Vibe — 3D ring, Shopify-safe
(function(){
  const root = document.querySelector('.vv-section');
  const ring = document.getElementById('ring');
  const viewport = document.getElementById('viewport');
  const arrows = { prev: document.getElementById('chevPrev'), next: document.getElementById('chevNext') };
  const layer = document.getElementById('vv-editor-layer');
  if(!root || !ring || !viewport) return;

  // -------- helpers
  const cssVar = (name,val)=> root.style.setProperty(name, String(val));

  function isEdit(){ return root.classList.contains('vv-edit'); }
  function syncEdit(){ root.classList.toggle('vv-edit', !!(layer && layer.classList.contains('open'))); }
  const mo = new MutationObserver(syncEdit);
  if (layer) mo.observe(layer, { attributes:true, attributeFilter:['class'] });
  document.addEventListener('DOMContentLoaded', syncEdit, { once:true });

  // -------- build slides from embedded JSON (temporary demo content)
  const dataEl = document.getElementById('vv-slides-data');
  const data = dataEl ? (JSON.parse(dataEl.textContent || '{}')) : { slides: [] };
  const slides = Array.isArray(data.slides) ? data.slides : [];
  slides.forEach((s,i)=>{
    const el = document.createElement('figure'); el.className='slide';
    const fit = document.createElement('div'); fit.className='media-fit'; el.appendChild(fit);
    if (s.media_type === 'video' && s.video_url){
      const v = document.createElement('video'); v.src=s.video_url; v.loop=true; v.controls=false; v.playsInline=true; fit.appendChild(v);
    } else if (s.image){
      const img = document.createElement('img'); img.src=s.image; img.alt=s.title||('Slide '+(i+1)); fit.appendChild(img);
    } else {
      el.textContent = s.title || ('Slide '+(i+1));
    }
    ring.appendChild(el);
  });

  // -------- responsive sizing + layout
  let base = 0;
  function computeSizes(){
    // card width ~18% of canvas, clamped by CSS; radius ~2.25 * card width
    const w = viewport.clientWidth;
    const cardW = Math.max(180, Math.min(320, w * 0.18));
    cssVar('--card-w', cardW + 'px');
    cssVar('--card-h', (cardW * 1.5) + 'px');
    cssVar('--ring-r', (cardW * 2.25) + 'px');
    layout();
  }

  function layout(){
    const nodes = Array.from(ring.children);
    if(!nodes.length) return;
    const R = parseFloat(getComputedStyle(root).getPropertyValue('--ring-r')) || 560;
    const step = 360 / nodes.length;
    nodes.forEach((el, i) => {
      const angle = base + i * step;
      el.style.transform = `translate(-50%,-50%) rotateY(${angle}deg) translateZ(${R}px)`;
    });
  }

  window.addEventListener('resize', computeSizes, { passive:true });
  computeSizes();

  // -------- drag spin (OFF in edit mode)
  let dragging=false, lastX=0, lastT=0, raf=null, vdeg=0;
  const DEG_PER_PX = 0.18;
  function cancelFling(){ if(raf){ cancelAnimationFrame(raf); raf=null; } }
  function fling(){
    cancelFling();
    const FRICTION=0.965, MIN=0.002;
    let prev = performance.now();
    function step(){
      const now = performance.now();
      const dt = (now - prev) / 1000; prev = now;
      vdeg *= FRICTION;
      if (Math.abs(vdeg) < MIN){ raf=null; return; }
      base -= vdeg * dt * 1000;
      layout();
      raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
  }
  function onDown(ev){
    if (isEdit()) return;
    dragging = true; cancelFling(); document.body.style.userSelect='none';
    const p = ('touches' in ev) ? ev.touches[0] : ev; lastX = p.clientX; lastT = performance.now();
  }
  function onMove(ev){
    if (!dragging) return;
    const p = ('touches' in ev) ? ev.touches[0] : ev;
    const x = p.clientX; const now = performance.now();
    const dx = x - lastX; const dt = now - lastT || 16;
    vdeg = (dx * DEG_PER_PX) / dt;
    base -= dx * DEG_PER_PX;
    layout(); lastX = x; lastT = now; ev.preventDefault();
  }
  function onUp(){ if(!dragging) return; dragging=false; document.body.style.userSelect=''; fling(); }

  viewport.addEventListener('pointerdown', onDown, { passive:true });
  window.addEventListener('pointermove', onMove, { passive:false });
  window.addEventListener('pointerup', onUp, { passive:true });
  window.addEventListener('pointercancel', onUp, { passive:true });

  // -------- edit-only arrows: left = 3 left, right = 3 right
  function rotateBySlides(stepsLeft){
    const n = Math.max(1, ring.children.length);
    base += (360 / n) * stepsLeft;
    layout();
  }
  if (arrows.prev) arrows.prev.addEventListener('click', e => { if(!isEdit()) return; rotateBySlides(3);  e.preventDefault(); });
  if (arrows.next) arrows.next.addEventListener('click', e => { if(!isEdit()) return; rotateBySlides(-3); e.preventDefault(); });

  // -------- in edit mode: clicking a slide selects it (no enlarge)
  ring.addEventListener('click', (e)=>{
    if (!isEdit()) return;
    e.preventDefault(); e.stopPropagation();
    const slide = e.target.closest('.slide');
    if (!slide) return;
    ring.querySelectorAll('.slide.selected').forEach(s => s.classList.remove('selected'));
    slide.classList.add('selected');
  }, true);

  // close button for scaffold panel
  if (layer){
    const closeBtn = layer.querySelector('[data-close]');
    if (closeBtn) closeBtn.addEventListener('click', ()=> layer.classList.remove('open'));
  }
})();
